import { Box, LinearProgress, Typography } from "@mui/material";

interface IHourProgressProps {
    estimatedHours?: number;
    hourProgress: {
        minutesDone: number;
        percentageOfHoursDone: number;
    };
    expectedMinutes?: number;
}

const lessThanTen = (value: number): string =>
    value < 10 ? `0${value}` : value.toString();

const minutesToHours = (receivedMinutes: number): string => {
    const hours = Math.floor(receivedMinutes / 60);
    const minutes = receivedMinutes % 60;
    return `${lessThanTen(hours)}:${lessThanTen(minutes)}`;
};

export const HourProgress = ({
    hourProgress,
    expectedMinutes,
    estimatedHours,
}: IHourProgressProps) => {
    const timeDone = hourProgress?.minutesDone ?? 0;

    const hasEstimatedHours = typeof estimatedHours === "number";

    const estimatedMinutes = hasEstimatedHours
        ? Math.round(estimatedHours * 60)
        : 0;

    const totalExpectedMinutes = hasEstimatedHours
        ? estimatedMinutes
        : expectedMinutes ?? 0;

    const percentageDoneValue =
        totalExpectedMinutes > 0
            ? (timeDone / totalExpectedMinutes) * 100
            : hourProgress?.percentageOfHoursDone ?? 0;

    let percentageBarColor: "primary" | "warning" | "error" = "primary";
    if (percentageDoneValue > 110) {
        percentageBarColor = "error";
    } else if (percentageDoneValue > 100) {
        percentageBarColor = "warning";
    }

    const displayPercentage = Math.min(percentageDoneValue, 100);

    return (
        <Box
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
        >
            <Box display="flex" justifyContent="space-between" width="100%">
                <Typography variant="body2" color="text.secondary">
                    {minutesToHours(timeDone)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {percentageDoneValue.toFixed(2)}%
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {minutesToHours(totalExpectedMinutes)}
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={displayPercentage}
                color={percentageBarColor}
                sx={{
                    width: "100%",
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: "#E0E0E0",
                }}
            />
        </Box>
    );
};
